import { Component, OnInit, OnChanges, Output, Input, EventEmitter } from '@angular/core';

import { PublicJobService } from '../../../../../public/services/public-job.service';
import { IInlineEdit } from '../../inline-edit';


export class JobTitlesComponent implements OnInit, OnChanges, IInlineEdit {

	 public fingerprint: string = '';
	 public data: string = '';
	 public onSave = new EventEmitter<any>();
	 public onCancel = new EventEmitter<any>();

	public state: string = 'passive';

	public jobTitles: any;
	public jobTitlesSelectedValues: any[];
	public localData: any[];
	public initialData: any[];

	constructor(
		private publicJobService: PublicJobService) {}

	// Lifecycle Events
	public ngOnInit(): void {
		if (!this.fingerprint) {
			throw 'The "fingerprint" attribute is required!';
		}
		this.getJobTitles();
		this.jobTitlesSelectedValues = this.initialData.map((item) => item.id);
	}

	public ngOnChanges(changes: any): void {
		if (changes.hasOwnProperty('data') && changes['data'].currentValue) {
			this.localData = JSON.parse(JSON.stringify(changes['data'].currentValue));
			this.initialData = JSON.parse(JSON.stringify(changes['data'].currentValue));
			this.jobTitlesSelectedValues = this.localData.map((item) => item.id);
		}
	}

	// Events
	public onSaveClick(): void {
		let data = {
			fingerprint: this.fingerprint,
			data: this.localData
		};
		this.onSave.next(data);
		this.onChangeStateMode('passive');
	}

	public onCancelClick(): void {
		this.restoreData();
		this.onChangeStateMode('passive');
		this.onCancel.next(this.initialData);
	}

	public onChangeStateMode(state: string): void {
		this.state = state;
	}

	public onChosenChange(changes: any): void {
		if (changes && typeof changes.default !== 'undefined') {
			this.localData = changes.default;
		}
	}

	// Service Call
	private getJobTitles(): void {
		this.publicJobService.getJobTitles().subscribe(
			(jobTitles) => {
				this.jobTitles = jobTitles;
			}
		);
	}

	// Helpers
	private restoreData(): void {
		this.localData = null;
		this.localData = JSON.parse(JSON.stringify(this.initialData));
	}
static ctorParameters() { return [ { type: PublicJobService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/inline-edit/components/job-titles/job-titles.component.ts